var map = {
	"./berlinfuchs/project-preview.jpg": 9,
	"./digital-data-collection/project-preview.jpg": 10,
	"./droplet/project-preview.jpg": 11,
	"./dynamic-polyfill-module/project-preview.jpg": 13,
	"./maria-jose-moreno/project-preview.jpg": 14,
	"./robots-and-ai/project-preview.jpg": 15,
	"./zissel/project-preview.jpg": 16
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;


//////////////////
// WEBPACK FOOTER
// ./assets/projects ^\.\/.*\/project\-preview\.jpg$
// module id = 17
// module chunks = 0